import { extendTheme } from '@chakra-ui/react';

import { theme as baseRevelioTheme } from '@revelio/styles';

import type { ResolvedBrandConfig } from './brand-config';

export function createBrandedTheme(brand: ResolvedBrandConfig) {
  return extendTheme(baseRevelioTheme, {
    colors: {
      green: brand.primaryColor,
      greenAlpha: {
        500: hexToRgba(brand.primaryColor[500], 0.1),
      },
      // Dedicated sidebar colorScheme — separate from navyBlue so that
      // whitelabelling only affects sidebar-scoped usages, not general
      // UI chrome that uses `navyBlue.*` (tooltips, menus, icons, etc.).
      sidebar: brand.sidebarColor,
      // UI chrome text / tooltip backgrounds. Defaults to Revelio navy
      // when the brand doesn't set `textColor`. The 50–900 shades feed
      // `text.*` tokens (tooltips etc.); the semantic aliases
      // (`primary`, `inactive`, `lowContrast`) keep legacy usages in
      // sync with the brand's dark-neutral.
      text: {
        ...brand.textColor,
        primary: brand.textColor[500],
        inactive: brand.textColor[500],
        lowContrast: brand.textColor[100],
      },
    },
  });
}

function hexToRgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
